/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect, useState} from 'react';
import {Database} from "../../APIClient.jsx";
import GridElement from "./GridElement.jsx";
import {Socket} from "../../Socket.js";
import {useSub} from "subscription";
import {UI} from "../../UIGenerator.jsx";
import {Nodes} from "../../Objects/Nodes.jsx";

const StatusGridNodes = () => {
    const [elements, setElements] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let nodesData = await Nodes().listAll();
                setElements(nodesData?.recordset || nodesData || []);
            } catch (err) {
                console.error("Error fetching node data:", err);
            }
        };
        fetchData();
    }, []);

    useSub(() => Database.table("Nodes", "app").onChange((change) => {
        setElements(prev => Socket.applyChange(prev, change));
    }, []), "liveStatusGridNodesData");

    return (
        <div className={" gap-1.5 flex flex-wrap p-2"}>
            {elements.map(element => {
                return <GridElement key={element.indexKey} elementId={element.indexKey} name={"Nodes"} onClick={() => {
                    UI.page().navigate({
                        pathname: "/n/" + element.indexKey
                    })
                }}/>
            })}
        </div>
    );
}

export default StatusGridNodes;